import { App } from "antd";
import { useDispatch } from "react-redux";
import { useCallback, useState } from "react";
import {
  finishStep,
  previewStep,
  resetFields,
  uploadBase64,
} from "store/bailiff/bailiff/document/bailiff_document.action";
import { setOrderBailiffAll } from "store/bailiff/payment/order/order_bailiff.action";

//
//component
//redux
//selector
//actions
//utils
//hook
//str

export const useBailiffConvert = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();

  // -------------------------- FUNCTION ------------------------

  // nhảy qua khu vực tải file ở bước 1.
  const handleNavPreview = () => {
    dispatch(previewStep());
  };

  // upload và tải lên server bước 2.
  const handleNavFinish = () => {
    dispatch(finishStep());
  };

  const handleConvertAudio = async (audio) => {
    if (!audio) return message.error("File not found!");

    setLoading(true);
    const { file, fileName } = audio;

    // chuyển step.
    handleNavFinish();

    // upload lên server.
    dispatch(
      uploadBase64({ file, fileName }, (res) => {
        setLoading(false);
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  const turnBack = useCallback(async () => {
    console.log("trigger");
    dispatch(resetFields());
    dispatch(setOrderBailiffAll(null));
  }, [dispatch]);

  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN ----------------------------
  return { loading, handleConvertAudio, handleNavPreview, turnBack };
};
